import { Alert as MuiAlert, AlertColor } from '@mui/material';
import styled from '@emotion/styled';
import { spacing } from '@mui/system';

import { useUserMessageStore } from '../../stores';

const Alert = styled(MuiAlert)(spacing);

function MessageAlert() {
  const userMessage = useUserMessageStore.use.userMessage();
  const messageType = useUserMessageStore.use.messageType();

  return (
    userMessage && (
      <Alert mt={2} mb={3} severity={messageType as AlertColor}>
        {userMessage}
      </Alert>
    )
  );
}

export default MessageAlert;
